import isEmpty from 'lodash.isempty';
import {
  APPLICATION_FUNDING_TYPE,
  APPLICATION_TYPE,
  IRA_APPLICATION_FUNDING_TYPES,
} from '../constants';
import { parseEnumType } from './enumMappers';

export const getBackRoute = (
  activeItem,
  ApplicationType,
  funding,
  IraApplicationFundingResponse,
) => {
  if (!activeItem || isEmpty(activeItem)) {
    return '/';
  }
  // If not IRA Go into this IF
  if (
    APPLICATION_TYPE[ApplicationType] !== APPLICATION_TYPE[3] &&
    APPLICATION_TYPE[ApplicationType] !== APPLICATION_TYPE[4]
  ) {
    // IF Amount is defined, on Back go to Previous Route, if not go to PreSkipRoute
    if (funding?.Amount) {
      // Get the Finding Type, because different funding types have different previous Paths
      const fundingType = parseEnumType(
        APPLICATION_FUNDING_TYPE,
        funding?.BankFundingType,
      );

      // For Non Joint Application Types, PreviousPath is an object with multiple keys
      // Depending on the application type, return different key from object.
      switch (fundingType) {
        case APPLICATION_FUNDING_TYPE[0]:
          return activeItem.previousPath.PLAID;
        case APPLICATION_FUNDING_TYPE[2]:
          return activeItem.previousPath.WIRE;

        case APPLICATION_FUNDING_TYPE[3]:
          return activeItem.previousPath.CHECK;

        case APPLICATION_FUNDING_TYPE[4]:
          return activeItem.previousPath.CRYPTOCURRENCY;

        default:
          break;
      }

      return activeItem.previousPath;
    }

    // If not Ira and no Amount Defined return preSkipPath
    return activeItem.preSkipPath;
  }

  if (APPLICATION_TYPE[ApplicationType] === APPLICATION_TYPE[4]) {
    return activeItem.previousPath;
  }

  // If IRA Transfer go to skip path, because amount is in the modal and not as path.
  if (
    parseEnumType(
      IRA_APPLICATION_FUNDING_TYPES,
      IraApplicationFundingResponse.IRAFundingType,
    ) === parseEnumType(IRA_APPLICATION_FUNDING_TYPES, 1)
  ) {
    return activeItem.preSkipPath;
  }
  // if Amount Defined go to previous Path
  if (IraApplicationFundingResponse?.Amount) {
    if (
      parseEnumType(
        IRA_APPLICATION_FUNDING_TYPES,
        IraApplicationFundingResponse.IRAFundingType,
      ) === parseEnumType(IRA_APPLICATION_FUNDING_TYPES, 2)
    ) {
      return activeItem.previousPath.ROLLOVER;
    }

    if (
      parseEnumType(
        IRA_APPLICATION_FUNDING_TYPES,
        IraApplicationFundingResponse.IRAFundingType,
      ) === parseEnumType(IRA_APPLICATION_FUNDING_TYPES, 3)
    ) {
      return activeItem.previousPath.ANNUAL_CONTRIBUTION;
    }

    return activeItem.previousPath;
  }
  // if Amount not defined go to preSkipPath
  return activeItem.preSkipPath;
};
